import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { CirclePicker } from 'react-color';
import { get } from "lodash"
import { Checkbox, Col, Row, Select } from 'antd';
// import { Button } from '@mui/material';
import { Button } from 'antd';
import NotesTextEditor from 'components/NotesTextEditor';
import { isHtmlNoteVisuallyEmpty } from 'utils/methods/htmlNoteUtils';
import { handleBubbleUpdateNote, handleCreateBubbleNote, handleGetBubbleByBook, handleListBubbleUserNotes } from "store/notes/thunks";
import { handleListTeacherClasses } from "store/classes/thunks";
import { useDispatch } from "react-redux";
import COLOR from "utils/constants/color";
import { useCurrentClass } from 'store/classes/selectors';
import { useCurrentOrg } from 'store/organizations/selectors';
import { useCurrentUser } from 'store/users/selectors';
import Loading from 'components/Loading';
import { useFocusOutside } from 'components/OnClickOutside';
import { ArrowBackIosOutlined } from '@mui/icons-material';
import useBadWords from 'components/hooks/words/badWords';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';

//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------
const Wrapper = styled.div`
    width: 100%;
    // margin-top:20px;

    @media (max-width: 1024px) {
        margin-top:0px;
    }
`;
const FormHeader = styled.span`
  // color: ${COLOR.black200};
  display: inline-block;
  // font-size: 16px;
  // font-weight: 600;
  margin-bottom: 4px;
  // color: #000;
  font-family: Arial;
  font-size: 17.5px;
  font-weight: 700;
`;

const FormDescription = styled.span`
  color: ${COLOR.black400};
  display: inline-block;
  font-size: 11px;
  font-weight: 500;
  line-height: 16px;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    display:none;
}
`;

const MultiClassLabel = styled.div`
  color: ${COLOR.black300};
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 6px;
`;

const parseNoteAccessable = (note) => {
    const raw = note?.accessable != null ? note.accessable : get(note, 'content.accessable');
    if (raw == null) return null;
    if (typeof raw === 'string') {
        try {
            return JSON.parse(raw);
        } catch {
            return null;
        }
    }
    return Array.isArray(raw) ? raw : null;
};

const buildTeacherNoteContentPayload = (noteData, applyToAllClasses, additionalClassIds, currentClass) => {
    if (applyToAllClasses) {
        return { content: noteData, accessable: ['All'] };
    }
    if (Array.isArray(additionalClassIds) && additionalClassIds.length > 0) {
        const selectedClassIds = [...new Set(additionalClassIds)].filter(
            (cid) => String(cid) !== String(currentClass?.id)
        );
        if (selectedClassIds.length > 0) {
            const accessable = [
                ...(currentClass?.id ? [{ classes_id: currentClass.id }] : []),
                ...selectedClassIds.map((id) => ({ classes_id: id })),
            ];
            return { content: noteData, accessable };
        }
    }
    return {
        content: noteData,
        accessable: currentClass?.id ? [{ classes_id: currentClass.id }] : [],
    };
};

//  ----------------------------------------------------------------------------
//  Component
//  ----------------------------------------------------------------------------
//
//  Note form
const   NoteForm = ({
    setShowNote,
    setIsEditing,
    viewNote,
    setViewNote,
    pageNotes,
    data,
    page,
    numberMasked,
    chapter,
    close = () => {},
    draggable= () => {},
    isEditing = false,
    newMaskNote = "",
    pageNumber = ""
}) => {
    const initialState = [{
        type: 'paragraph ',
        children: [
            {
                text: ''
            }
        ]
    }];
    const { ref, isFocused } = useFocusOutside();
    const newMaskIdForAll = numberMasked;
    const [focusedBook, setFocusedBook] = useState({});
    const initialNotes = pageNotes?.content?.content ? pageNotes?.content?.content : pageNotes?.content;
    const [noteData, setNoteData] = useState(initialNotes);
    const [colors, setColors] = useState(pageNotes ? pageNotes?.color?.color : null)
    const [loader, setLoader] = useState(false);
    const [teacherClassList, setTeacherClassList] = useState([]);
    const [additionalClassIds, setAdditionalClassIds] = useState([]);
    const [applyToAllClasses, setApplyToAllClasses] = useState(false);
    const [classListLoading, setClassListLoading] = useState(false);
    const dispatch = useDispatch();
    const currentClass = useCurrentClass();
    const currentOrg = useCurrentOrg();
    const currentUser = useCurrentUser();
    const isNoteEmpty = !noteData || isHtmlNoteVisuallyEmpty(noteData);
    const showMultiClassSelect = currentUser?.role === 'teacher' && (!pageNotes?.id || isEditing);
    const handleColorChange = (color) => {
        setColors({
            color: color.hex
        });
    };

    // useEffect(()=> {
    //     if(viewNote.userId===currentUser.id){
    //         setIsEditing(true);
    //     }else{
    //         setIsEditing(false);
    //     }

    // },[viewNote,currentUser])

    useEffect(()=>{
        setColors(pageNotes?.color?.color)
    },[pageNotes])

    useEffect(() => {
        if (currentUser?.role !== 'teacher') return;
        if (!pageNotes?.id) {
            setApplyToAllClasses(false);
            setAdditionalClassIds([]);
            return;
        }
        const list = parseNoteAccessable(pageNotes);
        if (list == null) {
            setApplyToAllClasses(false);
            setAdditionalClassIds([]);
            return;
        }
        const hasAll = list.some(
            (x) => x === 'All' || x === 'all' || (typeof x === 'string' && String(x).toLowerCase() === 'all')
        );
        if (hasAll) {
            setApplyToAllClasses(true);
            setAdditionalClassIds([]);
            return;
        }
        const ids = list
            .map((entry) => (entry && typeof entry === 'object' ? entry.classes_id : null))
            .filter(Boolean)
            .map(String)
            .filter((cid) => cid !== String(currentClass?.id));
        setApplyToAllClasses(false);
        setAdditionalClassIds(ids);
    }, [pageNotes?.id, pageNotes?.accessable, pageNotes?.content, currentClass?.id, currentUser?.role]);

    useEffect(() => {
        const fetchTeacherClasses = async () => {
            if (!showMultiClassSelect || !currentUser?.id) return;
            try {
                setClassListLoading(true);
                const list = await dispatch(handleListTeacherClasses(currentUser.id));
                const normalized = Array.isArray(list)
                    ? list
                        .map((cls) => {
                            const classId = cls?.id || cls?.classId || cls?.class_id;
                            const isCurrentClass = String(classId) === String(currentClass?.id);
                            const className = cls?.displayName || cls?.display_name || cls?.name || cls?.code || '';
                            return {
                                id: classId,
                                label: isCurrentClass ? `${className} (Current Class)` : className,
                                disabled: isCurrentClass,
                            };
                        })
                        .filter((cls) => cls?.id)
                    : [];
                setTeacherClassList(normalized);
            } catch (error) {
                setTeacherClassList([]);
            } finally {
                setClassListLoading(false);
            }
        };
        fetchTeacherClasses();
    }, [currentUser?.id, currentUser?.role, currentClass?.id, showMultiClassSelect, dispatch])

    const { getTextFromHtml } = useBadWords();
    const showAlert = useAlert();
    const onSaveAndClose = async () => {
        if (isNoteEmpty || !noteData) return
        if (focusedBook?.data?.length > 0) {
            setLoader(true);
            const text = getTextFromHtml(noteData);
            if(text?.trim()?.length === 0){
                showAlert('Note is empty', 'error');
                setLoader(false);
                return;
            }
            const id = isEditing ? focusedBook?.pageNotes?.id : pageNotes?.id;
            const updatePayload = showMultiClassSelect
                ? buildTeacherNoteContentPayload(noteData, applyToAllClasses, additionalClassIds, currentClass)
                : { content: noteData };
            const color = colors;
            await dispatch(handleBubbleUpdateNote(id, updatePayload, color));
        } else {
            setLoader(true);
            const text = getTextFromHtml(noteData);
            if(text?.trim()?.length === 0){
                showAlert('Note is empty', 'error');
                setLoader(false);
                return;
            }

            const contentPayload = showMultiClassSelect
                ? buildTeacherNoteContentPayload(noteData, applyToAllClasses, additionalClassIds, currentClass)
                : { content: noteData };
            const data = {
                content: contentPayload,
                color: colors,
                chapter: isEditing ? focusedBook?.chapter : chapter ,
                page: isEditing ? focusedBook?.page  : page,
                userId: currentUser?.id,
                classId: currentClass.id,
                orgId: currentOrg?.id,
                title: ''
            }
            await dispatch(handleCreateBubbleNote(data));
        }
        const bubbleData = {
            chapter,
            classId: get(currentClass, "id"),
            userId: get(currentUser, "id")
        }
        await dispatch(handleGetBubbleByBook(bubbleData))
        dispatch(handleListBubbleUserNotes(get(currentUser, "id")))
        setLoader(false);
        close();
    }



    useEffect(() => {
        setFocusedBook({ chapter, page, pageNotes, pageNumber, data });
    }, [chapter, page, pageNotes, pageNumber, data]);

    const handleBackToAllNotesPage =() => {
        setShowNote(false); 
        setIsEditing(false);    
    }
    const handleAllClassesToggle = (event) => {
        if (event?.target?.checked) {
            setApplyToAllClasses(true);
            setAdditionalClassIds([]);
            return;
        }
        setApplyToAllClasses(false);
    }

    const handleAdditionalClassChange = (ids) => {
        setApplyToAllClasses(false);
        setAdditionalClassIds(ids);
    }

    return (
        <Wrapper tabIndex={0} ref={ref} className={`${isFocused ? "disable-key-navigation" : ""}`}>
            <Row className='flex flex-row justify-between' style={{flexWrap: 'nowrap', gap: '12px' }}>
                <FormHeader>{focusedBook?.data?.length > 0 ? 'Edit a Note' : 'Add a Note'} {(pageNumber || newMaskIdForAll || newMaskNote) && `(Page. ${pageNumber || newMaskIdForAll || newMaskNote})`}</FormHeader>
                <ArrowBackIosOutlined onClick={handleBackToAllNotesPage} className="edit-icon-notes" style={{ fontSize: "30px", color: "#3E5F8F", cursor: "pointer" }}  />
                {/* <FormDescription>
                    Students will have their notes for the entire school year, motivate
                    them to write as many notes as they need. This is a great tool to
                    keep their work organized. You can write your notes here as well,
                    keep track of any important information.
                </FormDescription> */}
            </Row>

            <Row gutter={[0, 32]}>
                <Col span={24} style={{ padding: '0px 4px 12px', marginTop: "10px" }} className='bubbleCircleWraper circular-container'>
                    <CirclePicker onChangeComplete={handleColorChange}  />
                </Col>
            </Row>
            {showMultiClassSelect && (
                <Row gutter={[0, 8]} style={{ padding: '0 4px 8px' }}>
                    <Col span={24}>
                        <MultiClassLabel>
                            Apply this same note to multiple classes
                        </MultiClassLabel>
                        <Checkbox checked={applyToAllClasses} onChange={handleAllClassesToggle}>
                            All
                        </Checkbox>
                    </Col>
                </Row>
            )}
            
            {showMultiClassSelect && (
                <Row gutter={[0, 8]} style={{ padding: '0 4px 12px' }}>
                    <Col span={24}>
                        <Select
                            mode="multiple"
                            allowClear
                            loading={classListLoading}
                            disabled={applyToAllClasses}
                            placeholder={applyToAllClasses ? 'All' : 'Also save this note to other classes'}
                            value={additionalClassIds}
                            onChange={handleAdditionalClassChange}
                            style={{ width: '100%' }}
                            optionFilterProp="label"
                            maxTagCount={0}
                            maxTagPlaceholder={() => `${additionalClassIds.length} selected`}
                            options={teacherClassList.map((cls) => ({
                                label: cls.label,
                                value: cls.id,
                                disabled: cls.disabled,
                            }))}
                        />
                    </Col>
                </Row>
            )}
            <Row gutter={[0, 8]}  onMouseEnter={()=> draggable(true)} onMouseLeave={()=> draggable(false)}>
                <Col span={24}>
                    <NotesTextEditor
                        page="ebookAndBubble"
                        handleChange={setNoteData}
                        value={noteData}
                    />
                </Col>
            </Row>

            <Row>
                <div
                    style={{
                        position: "absolute",
                        bottom: '20px',
                        left: 0,
                        width: "100%",
                        backgroundColor: "#010A52",
                        height: "75px",
                        // borderRadius: "0% 0% 18px 18px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: '1000',
                    }}
                >
                    <Button
                        className="notesSaveCloseBtn notesSaveCloseBtnNw"
                        onClick={() => onSaveAndClose(isNoteEmpty)}
                        // onTouchStart={() => {
                        //     onSaveAndClose(isNoteEmpty)
                        // }}
                        style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
                        disabled={(isNoteEmpty || !noteData)}
                    >
                        {loader && <Loading size={17} />} Save and Close
                    </Button>
                </div>
            </Row>
        </Wrapper>
    );
};

export default NoteForm;
